import React from 'react'
import { Link } from "react-router-dom";

export default function Services() {
  return (
<ul>
<li><Link to='/digital-marketing'>Digital Marketing</Link></li>
<li><Link to='/devOps-consulting-services'>DevOps Consulting Services</Link></li>
<li><Link to='/website-and-software-development'>Website Design and Custom Software development</Link></li>
<li><Link to='/it-consulting-cloud-server-management'>IT Consulting & Cloud Server management</Link></li>
<li><Link to='/business-process-outsourcing'>Business Process Outsourcing</Link></li>
<li><Link to='/mobile-app-services'>Mobile App Development Services</Link></li>

</ul>
  )
}

